import { useState } from 'react'
import { Modal, Button } from 'antd'
import useTranslation from '@/hooks/useTranslation'
import { useDispatch, useSelector } from 'react-redux'
import {
  updateEmail,
  clearError,
} from '@/features/auth/apis/authSlice'
import { errorHandling, openNotification } from '@/utils/utils'

import InputAffix from '@/components/shared-components/form/InputAffix'
import VerifyEmailOTP from './VerifyEmailOTP'
import Close from '@/components/svgs/CloseModal'
import Email from '@/components/svgs/auth/Email'

const UpdateEmail = ({ open, setOpen }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { updateLoading } = useSelector((state) => state.auth)

  const [verifyOpen, setVerifyOpen] = useState(false)

  const [email, setEmail] = useState('')

  // HANDLE SUBMIT
  const handleSubmit = () => {
    dispatch(updateEmail(email))
      .unwrap()
      .then((data) => {
        openNotification('success', data.message)
        setOpen(false)
        setVerifyOpen(true)
      })
      .catch((error) => openNotification('error', errorHandling(error)))
  }

  return (
    <>
      <Modal
        className='!w-[32rem]'
        title={null}
        open={open}
        onCancel={() => {
          setOpen(false)
          dispatch(clearError())
        }}
        footer={null}
        closable={false}
        centered
      >
        <div className='text-center mb-32 mt-16'>
          <h3 className='text-xl font-semibold capitalize mb-16'>
            {t('Update Email Address')}
          </h3>
          <p className='text-dimmed leading-6 text-sm'>
            {t('update email text')}
          </p>
        </div>

        <div className='form-type_5'>
          <InputAffix
            placeholder={t('form.email.ph')}
            name='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={<Email style='h-24' />}
          />
        </div>

        <Button
          className='btn-green text-base font-semibold tracking-wide rounded-lg py-12 w-full h-auto mt-24'
          loading={updateLoading}
          onClick={handleSubmit}
        >
          {t('Update')}
        </Button>

        <Close
          style='absolute top-28 right-36 cursor-pointer'
          onClick={() => {
            setOpen(false)
            dispatch(clearError())
          }}
        />
      </Modal>

      <VerifyEmailOTP
        open={verifyOpen}
        setOpen={setVerifyOpen}
        newEmail={email}
      />
    </>
  )
}

export default UpdateEmail
